import { useChainId } from 'wagmi'

import { withSuspense } from '@/ui/utils/withSuspense'

import { BridgeSkeleton } from './components/skeleton/BridgeSkeleton'
import { BridgeView } from './views/BridgeView'
import { SuccessView } from './views/SuccessView'
import { useBridge } from './logic/useBridge'
import { BridgeObjective } from '@/features/actions/flavours/bridge/types'

interface BridgeContainerProps {
  withHeading?: boolean
}

function BridgeContainer({ withHeading }: BridgeContainerProps) {
  const bridge = useBridge()

  if (bridge.pageStatus.state === 'success') {
    // Convert BridgeObjective array to expected format for the component
    const swapObjectives: BridgeObjective[] = bridge.actions.map((action) => ({
      ...action,
      to: action.to || action.from, // Ensure 'to' is always present, fallback to 'from' if needed
    }))

    return (
      <SuccessView
        runConfetti={true}
        resetForm={bridge.pageStatus.resetForm}
        swapMode={bridge.pageStatus.successData!.swapMode}
        fromToken={bridge.pageStatus.successData!.from}
        actions={swapObjectives}
        isModal={!withHeading}
      />
    )
  }

  // Convert BridgeObjective array to expected format for the component
  const swapObjectives = bridge.actions.map((action) => ({
    ...action,
    to: action.to || action.from, // Ensure 'to' is always present, fallback to 'from' if needed
  }))

  // Create a modified bridge object with the compatible actions
  const bridgeWithCompatibleActions = {
    ...bridge,
    actions: swapObjectives,
  }

  return <BridgeView bridge={bridgeWithCompatibleActions} withHeading={withHeading} />
}

// @note: forces form to reset when network changes
function BridgeContainerWithKey(props: BridgeContainerProps) {
  const chainId = useChainId()

  return <BridgeContainer key={chainId} {...props} />
}

const BridgeContainerWithSuspense = withSuspense(BridgeContainerWithKey, BridgeSkeleton)

export { BridgeContainerWithSuspense as BridgeContainer }
